module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_engagement-studio-photo-d07fc029cc24923b2c479b64baacdde5.jpg";